import windowScrollTo from './window-scroll';
export default function anchorScrollSpy() {
  const navigation = document.querySelector('.js-toc');
  if (navigation) {
    const TableOfContents = {
      container: navigation,
      links: null,
      headings: null,
      intersectionOptions: {
        rootMargin: '-50px 0px 0px 0px',
        threshold: 0.5
      },
      previousSection: null,
      observer: null,
      init() {
        this.handleObserver = this.handleObserver.bind(this);
        this.setUpObserver();
        this.findLinksAndHeadings();
        this.observeSections();
        this.links.forEach(link => {
          link.addEventListener('click', this.handleLinkClick.bind(this));
        });
        const linkIndex = this.links.findIndex(link => link.href === document.location.href);
        if (this.links && linkIndex > -1) {
          this.links[linkIndex].classList.add('is-visible', 'is-active');
        }
      },
      handleLinkClick(evt) {
        const id = evt.target.getAttribute('href').replace('#', '');
        const section = this.headings.find(heading => heading.getAttribute('id') === id);
        if (!section) {
          return;
        }
        section.setAttribute('tabindex', -1);
        let customOffset = evt.target.getAttribute('data-custom-offset');
        if (!customOffset) {
          customOffset = 0;
        }
        const header = document.querySelector('header');
        header.classList.add('pointer-events-none');
        setTimeout(() => {
          header.classList.remove('pointer-events-none');
        }, 1000);
        windowScrollTo(section, customOffset);
        if (this.container.classList.contains('is-active')) {
          this.container.classList.remove('is-active');
        }
        evt.preventDefault();
      },
      handleObserver(entries) {
        entries.forEach(entry => {
          const href = `#${entry.target.getAttribute('id')}`;
          const link = this.links.find(l => l.getAttribute('href') === href);
          if (entry.isIntersecting && entry.intersectionRatio <= 1) {
            link.classList.add('is-visible');
            this.previousSection = entry.target.getAttribute('id');
          } else {
            link.classList.remove('is-visible');
          }
          this.highlightFirstActive();
        });
      },
      highlightFirstActive() {
        const firstVisibleLink = this.container.querySelector('.is-visible');
        this.links.forEach(link => {
          link.classList.remove('is-active');
        });
        if (firstVisibleLink) {
          firstVisibleLink.classList.add('is-active');
        }
        if (!firstVisibleLink && this.previousSection) {
          this.container.querySelector(`a[href="#${this.previousSection}"]`).classList.add('is-active');
        }
      },
      observeSections() {
        this.headings.forEach(heading => {
          if (heading) {
            this.observer.observe(heading);
          }
        });
      },
      setUpObserver() {
        this.observer = new IntersectionObserver(this.handleObserver, this.intersectionOptions);
      },
      findLinksAndHeadings() {
        this.links = [...this.container.querySelectorAll('a')];
        this.headings = this.links.map(link => {
          const id = link.getAttribute('href');
          let selector = null;
          try {
            selector = document.querySelector(id);
          } catch (err) {
            // eslint-disable-next-line no-console
            console.warn(err);
          }
          return selector;
        }).filter(link => link !== null);
      }
    };
    TableOfContents.init();
  }

  // Scroll to section on load
  window.addEventListener('load', () => {
    if (window.location.hash) {
      const {
        hash
      } = window.location;
      const section = document.querySelector(hash);
      if (section !== null) {
        windowScrollTo(section);
      }
    }
  });
}